import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-439">
      <div className="max-w-5xl mx-auto" data-id="element-440">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-441">
          Lo que <span className="text-[#00B4D8]" data-id="element-442">recibís</span>
        </h2>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-443">
          <div className="bg-black border border-[#00B4D8]/30 rounded-2xl p-6" data-id="element-444">
            <h3 className="text-[#00B4D8] text-xl font-black mb-2" data-id="element-445">
              🎾 LOS 6 TOMOS
            </h3>
            <p className="text-gray-400 text-sm mb-5" data-id="element-446">
              Para profesores de pádel de todos los niveles
            </p>
            <div className="space-y-4" data-id="element-447">
              <div className="flex items-center gap-3 text-white" data-id="element-448">
                <span className="text-xl" data-id="element-449">🟢</span>
                <div className="flex-1" data-id="element-450">
                  <span className="font-bold" data-id="element-451">
                    Tomo 1 — Iniciación (8va/7ma Categoría)
                  </span>
                  <span className="text-gray-300" data-id="element-452">
                    {' '}
                    40 clases · Fundamentos · Empuñadura · Derecha y Revés ·
                    Globo · Saque · Primeros puntos
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-453">
                <span className="text-xl" data-id="element-454">🟡</span>
                <div className="flex-1" data-id="element-455">
                  <span className="font-bold" data-id="element-456">
                    Tomo 2 — Principiante (6ta/5ta Categoría)
                  </span>
                  <span className="text-gray-300" data-id="element-457">
                    {' '}
                    40 clases · Pared de Fondo · Pared Lateral · Bandeja de
                    Aproximación · Volea de Control · Posicionamiento en Pareja
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-458">
                <span className="text-xl" data-id="element-459">🟠</span>
                <div className="flex-1" data-id="element-460">
                  <span className="font-bold" data-id="element-461">
                    Tomo 3 — Intermedio (4ta/3ra Categoría)
                  </span>
                  <span className="text-gray-300" data-id="element-462">
                    {' '}
                    40 clases · La Víbora · Bajada de Pared Ofensiva · Remate de
                    Potencia · Táctica de Transición · Situaciones Reales de
                    Partido
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-463">
                <span className="text-xl" data-id="element-464">🔴</span>
                <div className="flex-1" data-id="element-465">
                  <span className="font-bold" data-id="element-466">
                    Tomo 4 — Avanzado (2da/1ra Categoría)
                  </span>
                  <span className="text-gray-300" data-id="element-467">
                    {' '}
                    40 clases · Defensa de Doble Pared · Golpes Pro · Táctica
                    Pro · Gestión Mental · Preparación para Torneos
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-468">
                <span className="text-xl" data-id="element-469">🟣</span>
                <div className="flex-1" data-id="element-470">
                  <span className="font-bold" data-id="element-471">
                    Tomo 5 — Drills & Canastos Pro
                  </span>
                  <span className="text-gray-300" data-id="element-472">
                    {' '}
                    60 drills completos · Sección A a E · Para 1 a 4 alumnos ·
                    Todos los niveles · 5 Circuitos de Clase Completa · Tabla de
                    Referencia Rápida
                  </span>
                </div>
              </div>
              <div className="flex items-center gap-3 text-white" data-id="element-473">
                <span className="text-xl" data-id="element-474">⭐</span>
                <div className="flex-1" data-id="element-475">
                  <span className="font-bold" data-id="element-476">
                    Tomo 6 — Planificación Anual & Testeo
                  </span>
                  <span className="text-gray-300" data-id="element-477">
                    {' '}
                    Calendario 12 meses · Planificación mensual por nivel · 4
                    Fichas de Testeo · Sistema de Gestión Profesional · Plan de
                    Retención de Alumnos
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* What each tome includes */}
        <div className="bg-[#00B4D8]/5 border border-[#00B4D8]/30 rounded-2xl p-8 text-center" data-id="element-478">
          <h3 className="text-[#00B4D8] text-xl font-black mb-6" data-id="element-479">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-480">
            <div className="flex items-start gap-2 text-left" data-id="element-481">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-482">✅</span>
              <span className="text-white text-sm" data-id="element-483">
                Planificación anual lista para usar
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-484">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-485">✅</span>
              <span className="text-white text-sm" data-id="element-486">
                40 clases con objetivo, desarrollo y cierre
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-487">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-488">✅</span>
              <span className="text-white text-sm" data-id="element-489">
                Sistema "Scan & Play" (leés en 3 min antes de entrar)
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-490">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-491">✅</span>
              <span className="text-white text-sm" data-id="element-492">
                Evaluaciones + rúbricas (escala 1-5)
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-493">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-494">✅</span>
              <span className="text-white text-sm" data-id="element-495">
                Fichas de seguimiento por alumno
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-496">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-497">✅</span>
              <span className="text-white text-sm" data-id="element-498">
                Variantes para nivel más fácil y más difícil
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-499">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-500">✅</span>
              <span className="text-white text-sm" data-id="element-501">
                Material original ProfePack®
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-502">
              <span className="text-[#00B4D8] font-bold flex-shrink-0" data-id="element-503">✅</span>
              <span className="text-white text-sm" data-id="element-504">
                100% adaptado al sistema de categorías argentino
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}